import { ValidationResult } from './validation-result';
import { FormControl } from '@angular/forms';
import { ConsumidorFormatter } from '../../restrito/consumidor/shared/consumidor.model';

export class DateValidator {

  static brazilianDate(control: FormControl): ValidationResult {

    const dataInput = control.value;
    const validDate = DateValidator.dataBrasileira(dataInput);

    if (validDate) {
      return { 'brazilianDate': true };
    } else {
      return { 'brazilianDate': false };;
    }
  }

  static dataBrasileira(dataInput) {

    if (!dataInput) {
      return false;
    }

    if (dataInput.search('_') !== -1) {
      return false;
    }

    const brazilianDatePattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
    if (dataInput.match(brazilianDatePattern)) {

      return DateValidator.dateTest(dataInput);

    } else {

      return false;
    }
  }

  static dateTest(dataInput) {

    const pdate = dataInput.split('/');
    const dd = +(pdate[0]);
    const mm = +(pdate[1]);
    const yy = +(pdate[2]);

    const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let validDate = true;

    if (mm > 12) {
      validDate = false;
    }

    if (mm <= 0) {
      validDate = false;
    }

    if (dd > 31) {
      validDate = false;
     }

    if (dd <= 0) {
      validDate = false;
     }

     if (yy < 1850 || yy > 2500) {
      validDate = false;
    }

    if (validDate && (mm === 1 || mm > 2)) {

      if (dd > ListofDays[mm - 1]) {
        validDate = false;
      } else {
        validDate = true;
      }

    }

    if (mm === 2) {
      validDate = DateValidator.fevereiroTest(dd, mm, yy);
    }

    return validDate;
  }

  static fevereiroTest(dd, mm, yy) {

    let lyear = false;
    if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
      lyear = true;
    }
    if ((lyear === false) && (dd >= 29)) {
      return false;
    }
    if ((lyear === true) && (dd > 29)) {
      return false;
    }
    return true;
  }


  static validatorRegularDate(control: FormControl): ValidationResult {

      // A validação de uma data normal deve permitir que a data seja igual a data corrente.
      return  DateValidator.validatorDate(control, true);
  }


  static validatorBirthDate(control: FormControl): ValidationResult {

      // A validação da data de aniversário não deve permitir que a data seja igual a data do dia corrente.
      return  DateValidator.validatorDate(control, false);

  }

  static validatorDate(control: FormControl, permiteDataCorrente: boolean): ValidationResult {

    if (control.value == null) {
      return null;
    }

    const dataInput = control.value;

    if (dataInput == '__/__/____' || dataInput == '') {
      return null;
    }

    const validDate = DateValidator.dataBrasileira(dataInput);

    if (!validDate) {

      return { 'brazilianDate': false };

    } else {

      // ****************************************
      // * VALIDA DATA MAIOR QUE DATA ATUAL
      // ****************************************
      if (!dataInput) {
        return null;
      }

      if (control.value.search('_') !== -1) {
        return null;
      }
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1; // Janeiro é 0!
      const year = today.getFullYear();
      const objData = new Date(ConsumidorFormatter.strDate2Date(control.value));
      const dataSelecionada = {
        day: objData.getDate(),
        month: objData.getMonth() + 1, // Janeiro é 0!
        year: objData.getFullYear()
      };

      if (dataSelecionada.year > year) {
        return { 'dataInvalida': true };
      }

      if (dataSelecionada.year === year && dataSelecionada.month > month) {
        return { 'dataInvalida': true };
      }

      if (dataSelecionada.year === year && dataSelecionada.month === month && dataSelecionada.day > day) {

        return { 'dataInvalida': true };
      }

      if(permiteDataCorrente == false) {

        if (dataSelecionada.year === year && dataSelecionada.month === month && dataSelecionada.day == day) {

          return { 'dataIgualAtual': false };
        }
      }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/validators/date-validator.ts